// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --text-color: #000;
  --heading-color: black;
}

.dark-mode {
  --text-color: #fff;
  --heading-color: white;
}

.dark-date-picker, .light-date-picker {
  font-family: sans-serif;
}

.dark-date-picker {
  color: #fff;
}

.light-date-picker {
  color: #000;
}

.date-picker-container {
  display: flex;
  align-items: center;
  border-radius: 1vh;
  padding: 0.5vh;
  margin: 1vh;
  width: 100%;
}

.calendar-icon {
  width: 20px;
  margin-right: 1vh;
  flex-shrink: 0;
}

.date-picker-input {
  border: none;
  outline: none;
  min-height: 4vh;
  text-align: left;
  width: 100%;
  background: transparent;
  color: inherit;
}

.date-picker-popup-container {
  width: 100% !important;
}

.rmdp-container {
  width: 100% !important;
}

.rmdp-wrapper {
  width: 100% !important;
  background-color: var(--date-background-color);
  border: none;
  box-shadow: none;
  border-radius: 1vh;
}

.rmdp-shadow {
  box-shadow: none;
  border: none;
}

.rmdp-range {
  background-color: #ff4e3a;
}

.rmdp-day.rmdp-today span {
  background-color: #9e9dab;
}

.rmdp-panel-header,
.rmdp-header-values,
.rmdp-day {
  color: var(--heading-color);
}

.rmdp-panel-body li {
  background-color: transparent !important;
}

.rmdp-panel-body li .b-deselect {
  background-color: #ff4e3a !important;
}

.rmdp-day.rmdp-selected span:not(.highlight) {
  background-color: #ff4e3a;
  box-shadow: 0 0 3px #8798ad;
  color: #fff;
  border-radius: 1vh;
}

.rmdp-day span:hover {
  background-color: #ff4e3a !important;
}

.dark-ca-date-picker, .light-ca-date-picker {
  width: 100%;
}

.dark-ca-date-picker *::-webkit-scrollbar,
.light-ca-date-picker *::-webkit-scrollbar {
  width: 4px;
}

.dark-ca-date-picker *::-webkit-scrollbar-track,
.light-ca-date-picker *::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.dark-ca-date-picker *::-webkit-scrollbar-thumb,
.light-ca-date-picker *::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;  
}

.rmdp-panel.bottom .rmdp-panel-body {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 2vh;
}

.rmdp-panel.bottom .rmdp-panel-body li .b-deselect {
  display: none;
}

.dark-ca-date-picker .rmdp-week-day {
  color: #fff;
}

.light-ca-date-picker .rmdp-week-day,
.light-ca-date-picker .b-date {
  color: #000;
}

.rmdp-arrow {
  border: solid #afafaf;
  border-width: 0 2px 2px 0;
}

.rmdp-arrow-container:hover {
  background-color: #ff4e3a;
}

.rmdp-panel-header {
  display: none;
}

.rmdp-day {
  padding-right: .5vh;
  padding-left: .5vh;
}

.light-ca-date-picker {
  background-color: #fff;
}

.dark-ca-date-picker {
  background-color: #3e3b56;
}

/* Add these styles to your existing CSS file */

.custom-date-panel-header {
  padding: 10px;
  border-bottom: 1px solid #ccc;
  font-weight: bold;
}

.selected-ranges {
  font-weight: normal;
  white-space: pre-wrap;
  margin-top: 5px;
  font-size: 0.9em;
}
`, "",{"version":3,"sources":["webpack://./src/components/date-range-picker/DateRangePicker.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;EAC9C,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+CAA+C;;AAE/C;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[":root {\n  --text-color: #000;\n  --heading-color: black;\n}\n\n.dark-mode {\n  --text-color: #fff;\n  --heading-color: white;\n}\n\n.dark-date-picker, .light-date-picker {\n  font-family: sans-serif;\n}\n\n.dark-date-picker {\n  color: #fff;\n}\n\n.light-date-picker {\n  color: #000;\n}\n\n.date-picker-container {\n  display: flex;\n  align-items: center;\n  border-radius: 1vh;\n  padding: 0.5vh;\n  margin: 1vh;\n  width: 100%;\n}\n\n.calendar-icon {\n  width: 20px;\n  margin-right: 1vh;\n  flex-shrink: 0;\n}\n\n.date-picker-input {\n  border: none;\n  outline: none;\n  min-height: 4vh;\n  text-align: left;\n  width: 100%;\n  background: transparent;\n  color: inherit;\n}\n\n.date-picker-popup-container {\n  width: 100% !important;\n}\n\n.rmdp-container {\n  width: 100% !important;\n}\n\n.rmdp-wrapper {\n  width: 100% !important;\n  background-color: var(--date-background-color);\n  border: none;\n  box-shadow: none;\n  border-radius: 1vh;\n}\n\n.rmdp-shadow {\n  box-shadow: none;\n  border: none;\n}\n\n.rmdp-range {\n  background-color: #ff4e3a;\n}\n\n.rmdp-day.rmdp-today span {\n  background-color: #9e9dab;\n}\n\n.rmdp-panel-header,\n.rmdp-header-values,\n.rmdp-day {\n  color: var(--heading-color);\n}\n\n.rmdp-panel-body li {\n  background-color: transparent !important;\n}\n\n.rmdp-panel-body li .b-deselect {\n  background-color: #ff4e3a !important;\n}\n\n.rmdp-day.rmdp-selected span:not(.highlight) {\n  background-color: #ff4e3a;\n  box-shadow: 0 0 3px #8798ad;\n  color: #fff;\n  border-radius: 1vh;\n}\n\n.rmdp-day span:hover {\n  background-color: #ff4e3a !important;\n}\n\n.dark-ca-date-picker, .light-ca-date-picker {\n  width: 100%;\n}\n\n.dark-ca-date-picker *::-webkit-scrollbar,\n.light-ca-date-picker *::-webkit-scrollbar {\n  width: 4px;\n}\n\n.dark-ca-date-picker *::-webkit-scrollbar-track,\n.light-ca-date-picker *::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\n.dark-ca-date-picker *::-webkit-scrollbar-thumb,\n.light-ca-date-picker *::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n  outline: 1px solid slategrey;  \n}\n\n.rmdp-panel.bottom .rmdp-panel-body {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin: 2vh;\n}\n\n.rmdp-panel.bottom .rmdp-panel-body li .b-deselect {\n  display: none;\n}\n\n.dark-ca-date-picker .rmdp-week-day {\n  color: #fff;\n}\n\n.light-ca-date-picker .rmdp-week-day,\n.light-ca-date-picker .b-date {\n  color: #000;\n}\n\n.rmdp-arrow {\n  border: solid #afafaf;\n  border-width: 0 2px 2px 0;\n}\n\n.rmdp-arrow-container:hover {\n  background-color: #ff4e3a;\n}\n\n.rmdp-panel-header {\n  display: none;\n}\n\n.rmdp-day {\n  padding-right: .5vh;\n  padding-left: .5vh;\n}\n\n.light-ca-date-picker {\n  background-color: #fff;\n}\n\n.dark-ca-date-picker {\n  background-color: #3e3b56;\n}\n\n/* Add these styles to your existing CSS file */\n\n.custom-date-panel-header {\n  padding: 10px;\n  border-bottom: 1px solid #ccc;\n  font-weight: bold;\n}\n\n.selected-ranges {\n  font-weight: normal;\n  white-space: pre-wrap;\n  margin-top: 5px;\n  font-size: 0.9em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
